export default __webpack_public_path__ + "static/media/GateChain.bdfa0647.svg";